import { ICellInputValidationParameters } from '@common/types';

export const getCellInputSaveValue = ({ value, replacer }: { replacer?: ICellInputValidationParameters['replacer']; value: string }) => {
  if (replacer) {
    return value.replace(replacer.from, replacer.to);
  } else {
    return value;
  }
};
